import React, { FC } from 'react';
import Box from '@/components/UI/box/Box';
import Drawer from '@/components/UI/drawer/Drawer';
import styles from './ProductCardMapDrawer.module.scss';
import Icon from '@/components/UI/icon/Icon';
import Button from '@/components/UI/button/Button';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import Typography from '@/components/UI/typography/Typography';
import MapLoading from '@/components/search/products/mapSection/reusable/mapLoading/MapLoading';
type ProductCardMapDrawerProps = {
  open: boolean;
  handleClose: () => void;
  lat: string;
  long: string;
  id: number;
};

// const Map = dynamic(() => import('@/components/reusable/map/Map'), {
//   ssr: false,
//   loading: () => (
//     <Box style={{ height: '350px' }}>
//       <MapLoading />
//     </Box>
//   ),
// })

const HouseMapContainer = dynamic(() => import('@/components/houses/_reusable/houseInfo/houseMap/houseMapContainer/HouseMapContainer'), {
  ssr: false,
  loading: () => <Box style={{
    height: '350px'
  }}>
        <MapLoading />
      </Box>
});
const ProductCardMapDrawer: FC<ProductCardMapDrawerProps> = ({
  open,
  handleClose,
  lat,
  long,
  id
}) => {
  const router = useRouter();
  // const house = [
  //   {
  //     id,
  //     location: {
  //       latitude: lat,
  //       longitude: long,
  //     },
  //   },
  // ]

  return <Drawer open={open} onClose={handleClose} data-sentry-element="Drawer" data-sentry-component="ProductCardMapDrawer" data-sentry-source-file="ProductCardMapDrawer.tsx">
      <Box className={styles['map_drawer_container']} data-sentry-element="Box" data-sentry-source-file="ProductCardMapDrawer.tsx">
        <Box className={styles['map_drawer_header']} data-sentry-element="Box" data-sentry-source-file="ProductCardMapDrawer.tsx">
          <Box className={styles['close_icon']} onClick={handleClose} data-sentry-element="Box" data-sentry-source-file="ProductCardMapDrawer.tsx">
            <Icon name="close" type="highEmphasis" data-sentry-element="Icon" data-sentry-source-file="ProductCardMapDrawer.tsx" />
          </Box>
          <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="ProductCardMapDrawer.tsx">موقعیت مکانی اقامتگاه</Typography>
        </Box>
        <Box className={styles['map_section']} data-sentry-element="Box" data-sentry-source-file="ProductCardMapDrawer.tsx">
          <HouseMapContainer position={[lat, long]} data-sentry-element="HouseMapContainer" data-sentry-source-file="ProductCardMapDrawer.tsx" />
          {/* <Map isMobile houses={house as ProductListRecord[]} isCardDrawer /> */}
        </Box>
        <Box className={styles['map_drawer_footer']} data-sentry-element="Box" data-sentry-source-file="ProductCardMapDrawer.tsx">
          <Button format="outlined" onClick={handleClose} data-sentry-element="Button" data-sentry-source-file="ProductCardMapDrawer.tsx">
            بستن
          </Button>
          <Button format="primary" onClick={() => router.push(`/houses/show/${id}`)} data-sentry-element="Button" data-sentry-source-file="ProductCardMapDrawer.tsx">
            مشاهده اقامتگاه
          </Button>
        </Box>
      </Box>
    </Drawer>;
};
export default ProductCardMapDrawer;